// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RZAz","content":"styles_content__AK7HH","tableWrap":"styles_tableWrap__wo454"};